/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { EsercenteRegistrationForm } from '../model/esercente-registration-form';
// @ts-ignore
import { ExceptionResponseDTO } from '../model/exception-response-dto';
// @ts-ignore
import { GenericResponseDTO } from '../model/generic-response-dto';
// @ts-ignore
import { GetProfiloServizio409Response } from '../model/get-profilo-servizio409-response';
// @ts-ignore
import { GetProfiloServizio422Response } from '../model/get-profilo-servizio422-response';
// @ts-ignore
import { TerminiVersioneDTO } from '../model/termini-versione-dto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    EsercenteRegistrazioneServiceInterface,
    RegistraEsercenteRequestParams
} from './esercente-registrazione.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class EsercenteRegistrazioneService extends BaseService implements EsercenteRegistrazioneServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Versione corrente dei termini e privacy (esercente, pubblico).
     * Endpoint pubblico senza reCAPTCHA: serve al client per conoscere, prima della registrazione, la versione da dichiarare nel form e se la raccolta e\&#39; attiva.
     * @endpoint get /api/v1/esercente/registrazione/termini
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getTerminiRegistrazioneEsercente(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TerminiVersioneDTO>;
    public getTerminiRegistrazioneEsercente(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TerminiVersioneDTO>>;
    public getTerminiRegistrazioneEsercente(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TerminiVersioneDTO>>;
    public getTerminiRegistrazioneEsercente(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/esercente/registrazione/termini`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TerminiVersioneDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Registra un nuovo esercente titolare (self-service).
     * Endpoint pubblico protetto da reCAPTCHA. Crea un utente Keycloak disabilitato con ruolo ROLE_esercente, lo User locale (accountActivated&#x3D;false) e il ProfiloEsercente con i dati impresa, quindi invia la mail di attivazione. L\&#39;account resta inerte finché l\&#39;email non è verificata (PUT /api/v1/account/verification).
     * @endpoint post /api/v1/esercente/registrazione
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public registraEsercente(requestParameters: RegistraEsercenteRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<GenericResponseDTO>;
    public registraEsercente(requestParameters: RegistraEsercenteRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<GenericResponseDTO>>;
    public registraEsercente(requestParameters: RegistraEsercenteRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<GenericResponseDTO>>;
    public registraEsercente(requestParameters: RegistraEsercenteRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const esercenteRegistrationForm = requestParameters?.esercenteRegistrationForm;
        if (esercenteRegistrationForm === null || esercenteRegistrationForm === undefined) {
            throw new Error('Required parameter esercenteRegistrationForm was null or undefined when calling registraEsercente.');
        }
        const xRecaptchaToken = requestParameters?.xRecaptchaToken;

        let localVarHeaders = this.defaultHeaders;
        if (xRecaptchaToken !== undefined && xRecaptchaToken !== null) {
            localVarHeaders = localVarHeaders.set('X-recaptcha-token', String(xRecaptchaToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/esercente/registrazione`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<GenericResponseDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: esercenteRegistrationForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
